import interfaceAjax from '@/libs/InterfaceAjax';

export default {
    gather() {
        return interfaceAjax({
            url: '/admin/sta/gather',
        });
    },
    equipTypeSta(data) {
        return interfaceAjax({
            url: '/admin/sta/equipTypeSta',
            data
        });
    },
}
